module.exports = __webpack_public_path__ + "img/potencia_r_a.38ef8dce.svg";